<div class="bg-blue-500 bottom-0 fixed w-full p-2 mt-10 inline-flex" *ngIf="afAuth.authState | async as user">
<div class="text-lg mx-auto text-white">
  <img  src="../../../assets/images/logo_horizontal.png" class="inline-flex" width="120px">
  <small class="text-xs m-2">(v {{appVersion}})
    </small>
</div>
</div>


